export const authenticateUserURL = 'https://games-online-app.glitch.me/games/authenticate';
//export const authenticateUserURL = 'http://localhost:7000/games/authenticate';

export const loginURL = 'https://auth-jwt-games-online-app.glitch.me/login'
//export const loginURL = 'http://localhost:4000/login'

export const registerURL = 'https://auth-jwt-games-online-app.glitch.me/register'
//export const registerURL = 'http://localhost:4000/register'


export const ENDPOINT_TICTACTOEGAME = 'https://games-online-app.glitch.me/';
//export const ENDPOINT_TICTACTOEGAME = 'http://localhost:7000'


export const ENDPOINT_CHAT = 'https://chat-games-online-app.glitch.me/';
//export const ENDPOINT_CHAT = 'http://localhost:9000'